import { IUser } from "../../common/types";

export enum AppActions {
  SET_USER = "SET_USER",
}

export interface ISetUser {
  type: AppActions.SET_USER;
  user: IUser;
}

export function setUser(user: IUser): ISetUser {
  return {
    type: AppActions.SET_USER,
    user,
  };
}

export type AppAction = ISetUser;
